import * as React from "react";
import { SpsPageSelector } from "./SpsPageSelector";
import { SpsPagination } from "./SpsPagination";
export const SpsPaginationPropTypes = SpsPagination["propTypes"];

function SpsPaginationFunctionalExample(props) {
    const { "data-testid": testId } = props;
    const [page, setPage] = React.useState(2);
    const [pageSize, setPageSize] = React.useState(25);

    function handlePageChange(newPage, newPageSize) {
        console.log("change", newPage, newPageSize);
        setPage(newPage);
        setPageSize(newPageSize)
    }

    return (
        <React.Fragment>
            <SpsPagination
                totalResults={123}
                page={page}
                pageSize={pageSize}
                onPageChange={handlePageChange}
                data-testid={testId}
            />
            <span className="mr-2">page: {page}</span><span>pageSize: {pageSize}</span>
        </React.Fragment>
    );
}

// @ts-ignore
SpsPaginationFunctionalExample.reactLive = {
    code: `
        function Component () {
            const [page, setPage] = React.useState(2);
            const [pageSize, setPageSize] = React.useState(25);

            function handlePageChange(newPage, newPageSize) {
                console.log("change", newPage, newPageSize);
                setPage(newPage);
                setPageSize(newPageSize)
            }

            return (
                <React.Fragment>
                    <SpsPagination
                        totalResults={123}
                        page={page}
                        pageSize={pageSize}
                        onPageChange={handlePageChange}
                    />
                    <span className="mr-2">page: {page}</span><span>pageSize: {pageSize}</span>
                </React.Fragment>
            );
        }
        render(<Component />)
    `
};

function SpsPageSelectorFunctionalExample(props) {
    const { "data-testid": testId } = props;
    const pageChanged = val => {
        console.log(val);
    };
    return <SpsPageSelector numPages={25} onPageChange={pageChanged} data-testid={testId} />;
}

// @ts-ignore
SpsPageSelectorFunctionalExample.reactLive = {
    code: `
        function Component () {
            const pageChanged = val => {
                console.log(val);
            };
            return <SpsPageSelector numPages={25} onPageChange={pageChanged} />;
        }
        render(<Component />)
    `
};

export {
    SpsPaginationFunctionalExample,
    SpsPageSelectorFunctionalExample
};
